import type { FaireProductEntity } from "../../entity_types/product";

export const p_kqstp7nx27: FaireProductEntity = {
  token: "p_kqstp7nx27",
  type: "product",
  name: "Sugary Strawberry Maltose Squishy Toy",
  brandToken: "b_bya786doke",
  brandName: "Love and Repeat",
  imageUrl:
    "https://cdn.faire.com/fastly/ea495df37fd114d2872d6d24dc981d17488be20d7b44bda4e6590b80def10163.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9da5960a0212ee9c42face1d961edcad1f5d99368c937c16da12542f7519ece7.jpeg",
    "https://cdn.faire.com/fastly/f909cff3af2e2947da789ec4250efaa13c9485efa171fbedcb56c0d78ded569b.jpeg",
    "https://cdn.faire.com/fastly/47b4e2592c51ec6a8ae6b87e571af8e6493562ff7f0a8a201aee894a1ebaffaf.jpeg",
    "https://cdn.faire.com/fastly/dbcdb70f001a76dfb6448e62235a60a67fd4c5111326ef71f581b03cf0c5fce8.jpeg",
    "https://cdn.faire.com/fastly/a950fe1e1d30f51ff181bef8ad95d9c288dcb011146f7ca54298789d289441ca.jpeg",
    "https://cdn.faire.com/fastly/bd37b7a7a425c36c7c1afbe05d725d2f5fff5e51cbb99f3aa175188353fbb320.jpeg",
    "https://cdn.faire.com/fastly/3ddd7c170768346f39acaaa43118fa07179dfa823144c50e3d5f95afaf0380f3.jpeg",
    "https://cdn.faire.com/fastly/6843ae9b3d5ef3627f109be0df2d091302115d17a7f4cffea87c31a6eeae2111.jpeg",
    "https://cdn.faire.com/fastly/331a8d6a6af61c8307c92dd4301d041af628a34e781b988190fbef44d50aea9b.jpeg",
  ],
  priceDollars: 3.75,
  description:
    "Sugary Strawberry Maltose Stress Release Squishy Toy\r\n\r\n-Cute Squishy Fidget Toys, Fruit Stress Relief Toy, Squishies Toys for Kids and Adults, Party Favors,  Goodie Bag Stuffers. Pull it and Rub it and Play all day long.\r\n-4 Colors Assorted\r\n",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:39.696Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
